import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Puerto Rico Tier2 Submit": {
    parameters: {},
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "PR",
  },
};
